import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { fiItemsListTypeNameTextId } from '@fi-shared/utils/fi-items-list-type-name-text-id';
import {
    IItemsListFilter,
    ISelectedFilterItem,
} from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';
import { AppTextService } from '@fi-shared/app-text';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiAppSettings } from '@fi-shared/fi-app-settings';

@Component({
    selector: 'fi-filter-settings-summary',
    templateUrl: './fi-filter-settings-summary.component.html',
    styleUrls: ['./fi-filter-settings-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-filter-settings-summary' },
    standalone: false,
})
export class FiFilterSettingsSummaryComponent {
    @Input() currentFilter: IItemsListFilter;
    @Input() itemsCountText: string;
    @Input() itemsListType: FiItemsListType;
    @Input() selectedFilterItems: ISelectedFilterItem[] = [];
    @Output() onRemoveSelectedFilterItem = new EventEmitter<ISelectedFilterItem>();

    constructor(private appTextService: AppTextService) {}

    getFilterName(): string {
        if (!this.currentFilter.Id || !this.currentFilter.Name) {
            return this.appTextService.get('filter.my_filter');
        }
        return this.currentFilter.Name;
    }

    getItemsCountLabel(): string {
        return this.itemsCountText;
    }

    removeSelectedFilterItem(filterItem: ISelectedFilterItem) {
        this.onRemoveSelectedFilterItem.emit(filterItem);
    }
}
